import * as actions from "./actions";
import initialState from "./initialState";
import reducer from "./reducer";

export const communityActions = actions;
export const communityInitialState = initialState;
export const communityReducer = reducer;
